import { db } from '../../data/base';
import { doc, updateDoc, getDoc } from 'firebase/firestore';

/**
 * Updates the publication status of a catalog
 * @param {string} catalogId - The ID of the catalog to update
 * @param {string} status - The new status ('Published' or 'Unpublished')
 * @returns {Promise<object>} - The updated catalog data
 */
export async function updateCatalogStatus(catalogId, status) {
    try {
        // Validate inputs
        if (!catalogId) {
            console.error('[DEBUG] Error: catalogId is undefined or empty');
            throw new Error('Catalog ID is required');
        }

        if (!status) {
            console.error('[DEBUG] Error: status is undefined or empty');
            throw new Error('Status is required');
        }
        // Reference to the catalog document
        const catalogRef = doc(db, 'Catalogues', catalogId);

        // Check if the catalog exists before updating
        const catalogSnapshot = await getDoc(catalogRef);

        if (!catalogSnapshot.exists()) {
            console.error(`[DEBUG] Error: Catalog with ID ${catalogId} not found before update`);
            throw new Error(`Catalog with ID ${catalogId} not found`);
        }

        // Determine isPublic value based on status
        const isPublic = status === 'Published';

        // Update both status and isPublic fields
        await updateDoc(catalogRef, {
            status: status,
            isPublic: isPublic
        });

        // Get the updated catalog data
        const updatedCatalog = await getDoc(catalogRef);

        if (!updatedCatalog.exists()) {
            console.error(`[DEBUG] Error: Catalog with ID ${catalogId} not found after update`);
            throw new Error(`Catalog with ID ${catalogId} not found`);
        }

        const updatedData = updatedCatalog.data();

        // Return the updated catalog data
        return {
            id: updatedCatalog.id,
            ...updatedData
        };
    } catch (error) {
        console.error(`[DEBUG] Error updating catalog status to ${status}:`, error);
        throw error;
    }
}
